import './Loader.scss';

function Loader(props) {
	return (
		<p className="loader">{props.message}</p>
	)
}

export default Loader;